
import React from "react";
import { Control } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { DemographicsFormValues } from "./types";

interface PoliticalIncomeFieldsProps {
  control: Control<DemographicsFormValues>;
}

export const PoliticalIncomeFields: React.FC<PoliticalIncomeFieldsProps> = ({ control }) => {
  return (
    <>
      <FormField
        control={control}
        name="political_leaning"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Political Leaning</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select political leaning" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="very-progressive">Very Progressive</SelectItem>
                <SelectItem value="progressive">Progressive</SelectItem>
                <SelectItem value="moderate">Moderate</SelectItem>
                <SelectItem value="conservative">Conservative</SelectItem>
                <SelectItem value="very-conservative">Very Conservative</SelectItem>
                <SelectItem value="libertarian">Libertarian</SelectItem>
                <SelectItem value="other">Other</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="income_range"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Income Range (Annual)</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select income range" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="under-25k">Under $25,000</SelectItem>
                <SelectItem value="25k-50k">$25,000 - $50,000</SelectItem>
                <SelectItem value="50k-75k">$50,000 - $75,000</SelectItem>
                <SelectItem value="75k-100k">$75,000 - $100,000</SelectItem>
                <SelectItem value="100k-150k">$100,000 - $150,000</SelectItem>
                <SelectItem value="over-150k">Over $150,000</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
